import {Action, Reducer} from 'redux';
import {UserSettings} from '../../models/IUserSettings';
import {
  FETCHING_SSO_USER_ACEPID,
  FETCHING_USER_SETTINGS_BY_ACEPID,
  KnownAction,
  SET_SSO_USER_ACEPID_FAILED,
  SET_SSO_USER_ACEPID_FULFILLED,
  SET_USER_SETTINGS_BY_ACEPID_FAILED,
  SET_USER_SETTINGS_BY_ACEPID_FULFILLED,
} from './userSettingsActions';

export interface UserSettingsState {
  userSettings: UserSettings;
  acepID: string;
  isLoading: boolean;
  isLoggedIn: boolean;
  error: string;
  jwtToken: string;
  ssoUser: string;
}
export const reducer: Reducer<UserSettingsState> = (
  state: UserSettingsState | undefined,
  incomingAction: Action,
): UserSettingsState => {
  if (state === undefined) {
    return {
      isLoading: false,
      isLoggedIn: false,
      error: '',
      acepID: null,
      jwtToken: null,
      ssoUser: null,
      userSettings: {
        firstName: '',
        lastName: '',
        formalName: '',
        isValidUser: false,
        acepExpirationDate: '',
        acepMemberStatus: 0,
        acepMemberType: NaN,
        acepMemberRate: NaN,
        sempaExpirationDate: '',
        sempaMemberStatus: NaN,
        sempaMemberType: NaN,
        sempaMemberRate: NaN,
        ecmeCatalog: '',
        email2: '',
        address1: '',
        address2: '',
        city: '',
        stateProvince: '',
        postalCode: '',
        country: '',
        phone: '',
        priceLevel: NaN,
        isOnAutoRenewal: false,
        loginUI_ExpiryDate: '',
        loginUI_Join: '',
      },
    };
  }
  const action = incomingAction as KnownAction;
  switch (action.type) {
    case FETCHING_USER_SETTINGS_BY_ACEPID:
      return {
        ...state,
        isLoading: true,
      };
    case SET_USER_SETTINGS_BY_ACEPID_FULFILLED:
      return {
        ...state,
        userSettings: action.userSettings,
        ssoUser: action.ssoUser,
        isLoading: false,
        isLoggedIn: true,
      };
    case SET_USER_SETTINGS_BY_ACEPID_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case FETCHING_SSO_USER_ACEPID:
      return {
        ...state,
        isLoading: true,
      };
    case SET_SSO_USER_ACEPID_FULFILLED:
      return {
        ...state,
        acepID: action.acepID,
        isLoading: false,
        isLoggedIn: true,
      };
    case SET_SSO_USER_ACEPID_FAILED:
      return {
        ...state,
        error: action.error,
        jwtToken: '',
        isLoading: false,
      };
    default:
      return state;
  }
};
